export default "__VITE_ASSET__Cp5Or93N__"